import React from "react";
import { useTranslation } from "react-i18next";
import UploadFinancialData from "./UploadFinancialData";
import NavbarIconsGenericComponent from "../generic-nav-bar/NavbarIconsGenericComponent";
import { debugLogPages } from "../../app/helpers/debugHelper";

const ImportDataFinancialScreen = () => {
  debugLogPages(':: ImportDataFinancialScreen');

  const { t } = useTranslation();

  return (
    <>
      <NavbarIconsGenericComponent componentName="ImportDataFinancial" />

      <div className="d-flex justify-content-center page-title">{t("admin.importdata.financial.title")}</div>

      <hr className="line-hr" />

        <div>
        <UploadFinancialData />
        </div>
      
    </>
  );
};

export default ImportDataFinancialScreen;
